var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDdnLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1701.444,
    height: 242.729,
    viewBox: "0 0 1701.444 242.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.409,
    y1: -1.528,
    x2: 0.842,
    y2: 8.154,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.425,
    y1: -1.527,
    x2: 0.775,
    y2: 7.939,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.459,
    y1: -1.626,
    x2: 0.704,
    y2: 8.055,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 0.5,
    x2: 1.004,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.002,
    y1: 0.5,
    x2: -0.002,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.485,
    r: 5.628,
    gradientTransform: "translate(0.456) scale(0.089 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-747.243 -1327.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M362.779,1305.269h50.145c38.247,0,64.255,24.139,64.255,59.495s-26.008,59.5-64.255,59.5H362.779Zm49.126,104.2c29.407,0,48.274-18.019,48.274-44.706s-18.867-44.7-48.274-44.7H379.779v89.41Z",
    transform: "translate(720 70)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M503.185,1305.269h17V1424.26h-17Z",
    transform: "translate(720 70)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M658.211,1305.269V1424.26H644.272l-71.395-88.732v88.732h-17V1305.269h13.937L641.212,1394v-88.733Z",
    transform: "translate(720 70)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M776.349,1364.084h16.319v46.405c-11.9,10.031-28.386,15.13-45.044,15.13-36.549,0-63.407-25.669-63.407-60.855s26.858-60.853,63.746-60.853c18.87,0,34.847,6.288,45.726,18.357l-10.54,10.538c-9.858-9.519-21.078-13.766-34.506-13.766-27.538,0-47.426,19.209-47.426,45.724,0,26.18,19.888,45.725,47.255,45.725,10.031,0,19.377-2.209,27.877-7.647Z",
    transform: "translate(720 70)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M836.693,1303.911h47.082c37.737,0,63.236,24.819,63.236,59.495s-25.5,59.5-63.236,59.5H836.693Zm46.4,111.169c33.658,0,55.243-21.418,55.243-51.674s-21.585-51.673-55.243-51.673H845.361V1415.08Z",
    transform: "translate(720 70)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1121.847,1303.911V1422.9h-7.139l-81.081-103.352V1422.9h-8.668V1303.911h7.308l80.915,103.353V1303.911Z",
    transform: "translate(720 70)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1245.6,1363.916h8.329v44.538c-10.708,10.2-26.177,15.3-42.5,15.3-35.866,0-62.213-25.667-62.213-60.345s26.347-60.343,62.384-60.343c17.17,0,32.3,5.436,42.835,16.317l-5.437,5.78c-10.367-10.2-22.778-14.11-37.227-14.11-30.936,0-53.885,22.442-53.885,52.356,0,29.75,22.949,52.357,53.885,52.357,12.581,0,24.138-3.062,33.828-10.88Z",
    transform: "translate(720 70)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1385.827,1303.911V1422.9h-13.943l-71.392-88.732V1422.9h-17V1303.911h13.942l71.391,88.733v-88.733Z",
    transform: "translate(720 70)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1411.832,1363.406c0-34.844,26.86-60.853,63.4-60.853,36.209,0,63.069,25.838,63.069,60.853s-26.86,60.855-63.069,60.855C1438.692,1424.261,1411.832,1398.251,1411.832,1363.406Zm109.473,0c0-26.347-19.721-45.723-46.069-45.723-26.689,0-46.4,19.376-46.4,45.723s19.715,45.725,46.4,45.725C1501.584,1409.131,1521.305,1389.752,1521.305,1363.406Z",
    transform: "translate(720 70)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1728.687,1303.911,1688.91,1422.9h-17.848l-32.468-95.023-32.468,95.023h-18.19l-39.771-118.991h17.506l32.126,96.72,33.487-96.72h15.639l32.8,97.233,32.809-97.233Z",
    transform: "translate(720 70)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M974.531,1303.911h8.5V1422.9h-8.5Z",
    transform: "translate(720 70)",
    fill: "#606060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-738.243 -1323.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(802.18 1313.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M62.438,0A105.93,105.93,0,0,0,6,16.184c26.048,3.948,52.492,8.676,78.145,12.629,5.92,1.184,7.893,2.368,7.893,5.132,0,21.707.394,43.809,0,65.516-1.184,26.442,1.184,53.684,0,80.119,0,3.948-4.736,6.316-11.445,7.1-24.075,3.948-48.545,7.5-72.619,11.051a111.216,111.216,0,0,0,54.071,15A106.621,106.621,0,0,0,168.605,106.17,105.45,105.45,0,0,0,62.438,0Z",
    transform: "translate(17.286 0.001)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M89.3,153.5c.394-22.5-.394-45.387,0-67.884.394-18.549,0-37.494,0-56.044a4.618,4.618,0,0,0-3.948-4.736C65.614,20.1,46.667,14.967,27.327,10.626,21.413,9.048,15.1,7.862,9.571,6.678H6.02V6.284A26.209,26.209,0,0,1,.1,5.1V176.783a40.042,40.042,0,0,1,7.1,1.578,10.931,10.931,0,0,0,3.561-.394c8.676-2.368,16.577-4.736,25.258-6.316,15.393-3.948,31.574-7.5,47.357-11.445C86.928,159.024,89.3,157.05,89.3,153.5ZM78.245,95.477a7.772,7.772,0,0,1-8.676-7.1,8.327,8.327,0,0,1,8.676-7.1,7.772,7.772,0,0,1,8.676,7.1A5.435,5.435,0,0,1,83.369,93.5v1.184a2.368,2.368,0,0,1-1.578-.394,5.525,5.525,0,0,1-3.552,1.184Z",
    transform: "translate(-0.1 15.031)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 150.766,
    cy: 13.419,
    rx: 150.766,
    ry: 13.419,
    transform: "translate(738.243 1529.291)",
    fill: "url(#radial-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdnLogoDark);
export default __webpack_public_path__ + "static/media/ddn_logo_dark.d33f05b5ee094bdeb207c4351f1235f7.svg";
export { ForwardRef as ReactComponent };